import {
  Bell, FileSignature, FileText, FolderKanban, FolderOpen, Headphones, LayoutGrid, PackageCheck, Receipt, ScrollText, UserRound, Users,
} from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { registerAuditLabels, lazyPage } from "@vixio/ui";
import "./api";
import { PortalHomePanel, TermsGate } from "./HomePanel";
import { NotificationBell, NotificationsPage } from "./NotificationsPage";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const PortalAdminPage = lazyPage(() => import("./AdminPage"), "PortalAdminPage");
const ClientTermsPage = lazyPage(() => import("./AccountPages"), "ClientTermsPage");
const MyDataPage = lazyPage(() => import("./AccountPages"), "MyDataPage");
const DeliverablesPage = lazyPage(() => import("./DeliverablesPage"), "DeliverablesPage");
const FilesPage = lazyPage(() => import("./FilesPage"), "FilesPage");
const FinancePage = lazyPage(() => import("./FinancePage"), "FinancePage");
const LibraryPage = lazyPage(() => import("./LibraryPage"), "LibraryPage");
const TeamPage = lazyPage(() => import("./TeamPage"), "TeamPage");
const ProjectsPage = lazyPage(() => import("./ProjectsPage"), "ProjectsPage");
const ContractPage = lazyPage(() => import("./ServicesPages"), "ContractPage");
const ServicesPage = lazyPage(() => import("./ServicesPages"), "ServicesPage");
const ClientTicketPage = lazyPage(() => import("./TicketsPages"), "ClientTicketPage");
const ClientTicketsPage = lazyPage(() => import("./TicketsPages"), "ClientTicketsPage");

registerAuditLabels({
  "portal.account_upserted": "Conta do portal salva",
  "portal.access_granted": "Acesso ao portal liberado",
  "portal.access_revoked": "Acesso ao portal revogado",
  "portal.terms_published": "Termos do portal publicados",
  "portal.terms_accepted": "Termos do portal aceitos",
  "portal.document_shared": "Documento publicado no portal",
  "portal.deliverable_accepted": "Entregável aprovado pelo cliente",
  "portal.deliverable_rejected": "Entregável devolvido pelo cliente",
  "portal.invite_sent": "Convite do portal enviado por e-mail",
  "portal.contract_viewed": "Contrato lido no portal",
  "portal.ticket_reference": "Referência anexada ao chamado pelo cliente",
  "portal.phone_updated": "Telefone atualizado pelo cliente",
  "portal.colleague_invited": "Colega convidado pelo responsável do cliente",
  "portal.colleague_revoked": "Acesso de colega revogado pelo responsável do cliente",
  "portal.access_role_changed": "Papel no portal alterado",
  "portal.document_downloaded": "PDF baixado no portal",
  "portal.item_project_set": "Documento ligado a projeto",
  "portal.file_uploaded": "Arquivo enviado no portal",
  "portal.file_downloaded": "Arquivo baixado no portal",
  "portal.file_removed": "Arquivo removido do portal",
  "portal.notification_prefs_set": "Preferências de aviso alteradas",
  "portal.data_exported": "Dados exportados pelo titular no portal",
  "portal.account_previewed": "Conta do portal vista como cliente",
});

export default defineModuleUi({
  key: "portal",
  title: "Portal do cliente",
  domain: "delivery",
  icon: LayoutGrid,
  menu: [
    { path: "/entrega/portal", label: "Portal do cliente", minRole: "member", icon: LayoutGrid, order: 50, keywords: "cliente acesso termos aceite documentos convite" },
  ],
  routes: [{ path: "/entrega/portal", element: <PortalAdminPage />, minRole: "member" }],
  // Ordem dos itens = grupo no menu do portal (apps/os PortalLayout): < 100 acompanhar, 100 contratos e financeiro,
  // 200 documentos e cursos, 300 sua conta.
  portal: {
    menu: [
      { path: "/portal/projetos", label: "Projetos", minRole: "client", icon: FolderKanban, order: 10 },
      { path: "/portal/entregaveis", label: "Entregáveis", minRole: "client", icon: PackageCheck, order: 20 },
      { path: "/portal/chamados", label: "Chamados", minRole: "client", icon: Headphones, order: 40 },
      { path: "/portal/servicos", label: "Serviços contratados", minRole: "client", icon: FileSignature, order: 100 },
      { path: "/portal/financeiro", label: "Financeiro", minRole: "client", icon: Receipt, order: 110 },
      { path: "/portal/documentos", label: "Documentos", minRole: "client", icon: FileText, order: 200 },
      { path: "/portal/arquivos", label: "Arquivos", minRole: "client", icon: FolderOpen, order: 205 },
      { path: "/portal/meus-dados", label: "Meus dados", minRole: "client", icon: UserRound, order: 300 },
      { path: "/portal/equipe", label: "Equipe da empresa", minRole: "client", icon: Users, order: 302 },
      { path: "/portal/avisos", label: "Avisos", minRole: "client", icon: Bell, order: 304 },
      { path: "/portal/termos", label: "Termos de uso", minRole: "client", icon: ScrollText, order: 320 },
    ],
    routes: [
      { path: "/portal/projetos", element: <ProjectsPage />, minRole: "client" },
      { path: "/portal/entregaveis", element: <DeliverablesPage />, minRole: "client" },
      { path: "/portal/chamados", element: <ClientTicketsPage />, minRole: "client" },
      { path: "/portal/chamados/:id", element: <ClientTicketPage />, minRole: "client" },
      { path: "/portal/servicos", element: <ServicesPage />, minRole: "client" },
      { path: "/portal/servicos/:id", element: <ContractPage />, minRole: "client" },
      { path: "/portal/financeiro", element: <FinancePage />, minRole: "client" },
      { path: "/portal/faturas", element: <FinancePage />, minRole: "client" },
      { path: "/portal/documentos", element: <LibraryPage />, minRole: "client" },
      { path: "/portal/arquivos", element: <FilesPage />, minRole: "client" },
      { path: "/portal/equipe", element: <TeamPage />, minRole: "client" },
      { path: "/portal/avisos", element: <NotificationsPage />, minRole: "client" },
      { path: "/portal/meus-dados", element: <MyDataPage />, minRole: "client" },
      { path: "/portal/termos", element: <ClientTermsPage />, minRole: "client" },
    ],
    home: PortalHomePanel,
    homeOrder: 10,
    gate: TermsGate,
    topbar: NotificationBell,
  },
});

